import { render, staticRenderFns } from "./NewServerScreen.vue?vue&type=template&id=17e271ee&"
import script from "./NewServerScreen.vue?vue&type=script&lang=js&"
export * from "./NewServerScreen.vue?vue&type=script&lang=js&"
import style0 from "./NewServerScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports